export const dataHooks = {
  loader: 'address-input-loader',
  noResultsText: 'address-input-no-results-text',
};
